import React, { useEffect, useRef } from 'react';

const EmailIframeViewer = ({ html }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    const timer = setTimeout(() => {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      if (!doc) return;

      doc.open();
      doc.write(`
        <!DOCTYPE html>
        <html>
          <head>
            <meta charset="UTF-8" />
            <style>
              body {
                font-family: Arial, sans-serif;
                margin: 0;
                padding: 1rem;
                background: white;
              }
              img {
                max-width: 100%;
                height: auto;
              }
            </style>
          </head>
          <body>${html}</body>
        </html>
      `);
      doc.close();

      // Auto-resize
      const resize = () => {
        const height = doc.body.scrollHeight;
        iframe.style.height = `${height}px`;
      };
      resize();

      const observer = new ResizeObserver(resize);
      observer.observe(doc.body);
      iframe._observer = observer;
    }, 0);

    return () => {
      clearTimeout(timer);
      if (iframe._observer) iframe._observer.disconnect();
    };
  }, [html]);

  return (
    <iframe
      ref={iframeRef}
      title="Email content"
      sandbox="allow-same-origin allow-popups allow-forms"
      scrolling="no"
      style={{
        width: '100%',
        border: 'none',
        backgroundColor: 'white',
        transition: 'height 0.2s ease',
      }}
    />
  );
};
export default EmailIframeViewer;
